import {
    FETCH_ESTIMATE,
    FETCH_ESTIMATE_SUCCESS,
    FETCH_ESTIMATE_FAILED,
    CLEAR_ESTIMATE,
} from "../store/types";
import Polyline from "@mapbox/polyline";
import { firebase } from "../config/configureFirebase";
import { FareCalculator } from "../other/FareCalculator";
import { applyRoundOffIfEnabled } from "../other/RoundOffLogic";
import { onValue } from "firebase/database";
import store from "../store/store";

export const getEstimate = (bookingData) => async (dispatch) => {
    const { settingsRef } = firebase;

    dispatch({
        type: FETCH_ESTIMATE,
        payload: bookingData,
    });

    let res = bookingData.routeDetails;

    if (res) {
        let points = Polyline.decode(res.polylinePoints);

        let polypoints = [];

        let waypoints = points.map((point) => {
            polypoints.push([point[0], point[1]]);
            return {
                latitude: point[0],
                longitude: point[1],
            };
        });

        const zones = store.getState().zonelistdata.zones;

        onValue(
            settingsRef,
            (settingdata) => {
                let settings = settingdata.val();
                let distance = settings.convert_to_mile
                    ? res.distance_in_km / 1.609344
                    : res.distance_in_km;

                let { totalCost, grandTotal, convenience_fees } =
                    FareCalculator(
                        distance,
                        res.time_in_secs,
                        bookingData.carDetails,
                        bookingData.instructionData,
                        settings.decimal,
                        zones,
                        polypoints
                    );

                // Apply round-off logic to grandTotal before formatting
                const addonsData = store.getState().addondata;
                const roundedGrandTotal = grandTotal
                    ? applyRoundOffIfEnabled(grandTotal, addonsData)
                    : 0;

                console.log("🔍 Estimate RoundOff:", {
                    originalGrandTotal: grandTotal,
                    roundedGrandTotal: roundedGrandTotal,
                    difference: roundedGrandTotal - grandTotal,
                    addonsEnabled: !!(
                        addonsData &&
                        addonsData.data &&
                        addonsData.data.trip_amount_roundoff &&
                        addonsData.data.trip_amount_roundoff.enabled
                    ),
                });

                dispatch({
                    type: FETCH_ESTIMATE_SUCCESS,
                    payload: {
                        pickup: bookingData.pickup,
                        drop: bookingData.drop,
                        carDetails: bookingData.carDetails,
                        instructionData: bookingData.instructionData,
                        estimateDistance: parseFloat(distance).toFixed(
                            settings.decimal
                        ),
                        fareCost: totalCost
                            ? parseFloat(totalCost).toFixed(settings.decimal)
                            : 0,
                        estimateFare: roundedGrandTotal
                            ? parseFloat(roundedGrandTotal).toFixed(
                                  settings.decimal
                              )
                            : 0,
                        estimateTime: res.time_in_secs,
                        convenience_fees: convenience_fees
                            ? parseFloat(convenience_fees).toFixed(
                                  settings.decimal
                              )
                            : 0,
                        waypoints: waypoints,
                    },
                });
            },
            { onlyOnce: true }
        );
    } else {
        dispatch({
            type: FETCH_ESTIMATE_FAILED,
            payload: "No Route Found",
        });
    }
};

export const clearEstimate = () => (dispatch) => {
    dispatch({
        type: CLEAR_ESTIMATE,
        payload: null,
    });
};
